import { IonCol, IonContent, IonGrid, IonRow } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { _ALIAS_SUFFIX, _SMALL_SCREEN_WIDTH, _dict, _freeCards, _homeNodePath, _libName, _pathSeparator, _rootName, _topSentences } from './constants';
import './ExploreContainer.css';
import Grid from './Grid';
import { checkIfSentenceHasAudio, filterStrings, store, updateTopSentences } from './foo';
import { getTTSOptions, readSentence } from './useRecorder';
import Autocomplete from './Autocomplete';
import { useTts } from 'tts-react';
import SidebarSentence from './SidebarSentence';
import SidebarEditCards from './SidebarEditCards';
import YoutubeModal from './dialogs/YoutubeModal';
import { useUIStore } from './stateManagement/UIZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useURLStore } from './stateManagement/URLZustand';
import SidebarMenu from './SidebarMenu';


interface ContainerProps {
  mainContent: JSX.Element | null;
}

const ExploreContainer: React.FC<ContainerProps> = (props) => {
  const { resetSelectedLabels, isSidebarVisible, selectedLabelsUpdatedToggle,
    isGridMode } = useUIStore();
  const { l2Audio } = useTreeStore();
  const { isParentMode, lang, sentence, setSentence, topSentences, setTopSentences } = useGlobalStore();
  const { isSidebarHorizontal } = useUIStore();

  const [showGrid, setShowGrid] = useState(false);
  const [updateSignal, setUpdateSignal] = useState(0);
  const [topSentencesStringArrayOnly, setTopSentencesStringArrayOnly] = useState(topSentences.map((item: [string[], number]) => item[0])); //with no counting
  const [showAutocomplete, setShowAutocomplete] = useState(false);

  const [playAutoSound, setPlayAutoSound] = useState<boolean>(false);

  const [varUpdateTopSentences, setVarUpdateTopSentences] = useState(0);


  const { visibleLabels } = useURLStore();

  /*
    useEffect(() => {
      if (URLVars.nodePath) {
        if (nodes[URLVars.nodePath] === undefined
          && isParentMode === false
          && !isLibPath()) {
          history.push(getURLTo().home());
        }
      }
    }, []);*/

  useEffect(() => {

    setShowGrid(true);
    setSentence(sentence);

  }, [selectedLabelsUpdatedToggle]);


  useEffect(() => {
    if (isParentMode === false) {
      resetSelectedLabels();
    } else if (isParentMode === true) {
      setSentence([]);
    }

  }, [isParentMode])


  useEffect(() => {
    setTopSentencesStringArrayOnly(filterStrings(sentence, topSentences.map((item: [string[], number]) => item[0])));
  }, [sentence, updateSignal, topSentences, varUpdateTopSentences])





  /* [START] CODE SNIPPET FOR AUTO AUDIO IF NOT RECORDED */
  const { play } = useTts(getTTSOptions(lang, sentence));
  useEffect(() => {
    if (playAutoSound) {
      play();
      setPlayAutoSound(false);
    }
  }, [playAutoSound]);
  /* [END] CODE FOR AUTO AUDIO IF NOT RECORDED */


  const handleReadSentence = () => {
    if (sentence.length > 1) {
      let newTopSentences = updateTopSentences(topSentences, sentence);
      setTopSentences(newTopSentences);
      store("topSentences", newTopSentences);
      setVarUpdateTopSentences(1 - varUpdateTopSentences);
      //Already done above in useEffect! :
      //setTopSentencesStringArrayOnly(topSentences.map((item:string[]) => item[0]));
    }
    if (checkIfSentenceHasAudio(sentence, l2Audio) === false) {
      setPlayAutoSound(true);
    } else {
      readSentence(sentence, l2Audio);
    }

    setUpdateSignal(1 - updateSignal);
  };

  const handleAutocomplete = (item: string[]) => {
    if (!isParentMode) {
      setSentence(item)
    }
  }

  const handleReset = () => {
    if (isParentMode) {
      setTopSentences(_topSentences)
      setVarUpdateTopSentences(1 - varUpdateTopSentences);
      setUpdateSignal(1 - updateSignal);
      setShowAutocomplete(false);
      store("topSentences", _topSentences);
    }
  }


  return (
    <IonContent>

      <IonGrid style={{ padding: 0, margin: 0 }}>
        {isSidebarVisible && isParentMode === false && isSidebarHorizontal === true && <SidebarSentence
          sentence={sentence}
          handleReadSentence={handleReadSentence}
          showAutocomplete={showAutocomplete}
          setShowAutocomplete={setShowAutocomplete}


        />}
        {showGrid /* && (!parentMode || parentMode && showAutocomplete) */ && sentence != null ?
          <IonRow>
            <IonCol
              style={{
                overflowY: 'scroll',
                maxHeight: '100vh',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >

              <div style={{ display: showAutocomplete ? "block" : "none" }}>
                <Autocomplete topSentencesStringArrayOnly={topSentencesStringArrayOnly} handleAutocomplete={handleAutocomplete} handleReset={handleReset} lang={lang} />
              </div>
              <div style={{ display: showAutocomplete ? "none" : "block" }}
                id='pdfExport'
              >
                {props.mainContent === null || props.mainContent === undefined ? <Grid /> : props.mainContent}
              </div>



            </IonCol>
            {isSidebarVisible /*&& visibleLabels !== undefined && visibleLabels.length > 0*/ &&
              <>
                {isParentMode === false  /*|| (isParentMode === true && selectedLabelsKeys.length === 0)*/ ?

                  <>{isSidebarHorizontal === false && <SidebarSentence
                    sentence={sentence}
                    handleReadSentence={handleReadSentence}
                    showAutocomplete={showAutocomplete}
                    setShowAutocomplete={setShowAutocomplete}


                  />}</> :

                  isParentMode === true ?
                    <SidebarMenu />

                    :
                    (isGridMode === true || (isGridMode === false && visibleLabels && visibleLabels.length > 0)) ?
                      <SidebarEditCards /> :
                      null
                }</>}


          </IonRow>

          :

          <IonRow>
            <IonCol size="1"></IonCol>
            <IonCol size="11" style={{
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}>{props.mainContent === null || props.mainContent === undefined ? <Grid /> : props.mainContent}</IonCol>
          </IonRow>


        }

      </IonGrid>

      <YoutubeModal />

    </IonContent>

  );
};

export default ExploreContainer;